<div class="popular page" *ngIf="waterways">
  <div class="title">Popular Waterways</div>
  <div class="description">The most active fishing spots in {{ name }}</div>
  <div class="content">
    <div class="box" *ngFor="let waterway of waterways">
      <div class="box_info">
        <div class="box_title" (click)="navigateWaterway(waterway)">{{ waterway.name }}</div>
        <div class="box_description">{{ truncate(waterway.description) }}</div>
      </div>
      <div class="box_icons">
        <div class="box_icon_item">
          <div class="icon"><mat-icon svgIcon="catchOvIcon" mat-list-icon></mat-icon></div>
          <span>{{ waterway.catchCount || 0 }}</span>
        </div>
        <div class="box_icon_item">
          <div class="icon"><mat-icon svgIcon="spotOvIcon" mat-list-icon></mat-icon></div>
          <span>{{ waterway.spotCount || 0 }}</span>
        </div>
        <div class="box_icon_item">
          <div class="icon"><mat-icon svgIcon="followerIcon" mat-list-icon></mat-icon></div>
          <span>{{ waterway.memberCount || 0 }}</span>
        </div>
      </div>
    </div>
  </div>
</div>